// @ts-strict-ignore
import React, {FC, ReactNode} from 'react';
import clsx from 'clsx';

import {SvgIconReact} from 'common/components/svg-icon';
import {SvgIconType} from 'common/components/svg-icon/types';

import style from './action-button.module.styl';

interface ActionButtonProps {
  icon: string;
  onClick?: () => void;
  href?: string;
  target?: `_blank`;
  rel?: string;
  children: ReactNode;
  className?: string;
}

export const ActionButton: FC<ActionButtonProps> = ({
  icon,
  onClick,
  href,
  target,
  rel = href && target === `_blank` ? `noopener noreferrer` : undefined,
  children,
  className,
}) => {
  const classList = clsx(style.actionButton, className);

  // If href is provided, render an anchor tag
  if (href) {
    return (
      <a href={href} target={target} rel={rel} className={classList} onClick={onClick}>
        <SvgIconReact icon={icon as SvgIconType} />
        {children}
      </a>
    );
  }

  // Otherwise, render a button
  return (
    <button className={classList} onClick={onClick}>
      <SvgIconReact icon={icon as SvgIconType} />
      {children}
    </button>
  );
};
